export function PropertySkeleton({ compact = false }: { compact?: boolean }) {
  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden animate-pulse">
      {/* Image skeleton */}
      <div className={`bg-gray-300 w-full ${compact ? "h-40" : "h-52"}`} />

      {/* Content skeleton */}
      <div className={`${compact ? "p-4" : "p-6"} space-y-3`}>
        {/* Title */}
        <div className="h-6 bg-gray-300 rounded w-3/4" />

        {/* Price */}
        <div className="h-5 bg-gray-300 rounded w-1/2" />

        {/* Location */}
        <div className="h-4 bg-gray-300 rounded w-2/3" />

        {/* Icons row */}
        <div className="grid grid-cols-3 gap-2">
          <div className="h-4 bg-gray-300 rounded" />
          <div className="h-4 bg-gray-300 rounded" />
          <div className="h-4 bg-gray-300 rounded" />
        </div>

        {/* Button */}
        <div className="h-10 bg-gray-300 rounded mt-4" />
      </div>
    </div>
  )
}

export function PropertyGridSkeleton({ count = 8, compact = false }: { count?: number; compact?: boolean }) {
  const gridClasses = compact
    ? "grid-cols-1 md:grid-cols-2"
    : "grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"

  return (
    <div className={`grid gap-6 ${gridClasses}`}>
      {Array.from({ length: count }).map((_, index) => (
        <PropertySkeleton key={index} compact={compact} />
      ))}
    </div>
  )
}
